import { renderEditInputCell } from "../components/cell/GridEditInputCell.es.js";
import { gridStringOrNumberComparator } from "../hooks/features/sorting/gridSortingUtils.es.js";
import { getGridStringOperators, getGridStringQuickFilterFn } from "./gridStringOperators.es.js";
import { convertQuickFilterV7ToLegacy } from "./utils.es.js";
const GRID_STRING_COL_DEF = {
  width: 100,
  minWidth: 50,
  maxWidth: Infinity,
  hideable: true,
  sortable: true,
  resizable: true,
  filterable: true,
  groupable: true,
  pinnable: true,
  // @ts-ignore
  aggregable: true,
  editable: false,
  sortComparator: gridStringOrNumberComparator,
  type: "string",
  align: "left",
  filterOperators: getGridStringOperators(),
  renderEditCell: renderEditInputCell,
  getApplyQuickFilterFn: convertQuickFilterV7ToLegacy(getGridStringQuickFilterFn),
  getApplyQuickFilterFnV7: getGridStringQuickFilterFn
};
export {
  GRID_STRING_COL_DEF
};
//# sourceMappingURL=gridStringColDef.es.js.map
